export const GeoFenceColor = {
    Red: 'Red',
    Yellow: 'Yellow',
    Brown: 'Brown',
    Green: 'Green',
    Blue: 'Blue',
    Orange: 'Orange',

    get(color) {
        return this.all().find(x => x.value === color);
    },
    all() {
        return [
            {value: GeoFenceColor.Red, translationKey: 'geofence.color.red'},
            {value: GeoFenceColor.Yellow, translationKey: 'geofence.color.yellow'},
            {value: GeoFenceColor.Brown, translationKey: 'geofence.color.brown'},
            {value: GeoFenceColor.Green, translationKey: 'geofence.color.green'},
            {value: GeoFenceColor.Blue, translationKey: 'geofence.color.blue'},
            {value: GeoFenceColor.Orange, translationKey: 'geofence.color.orange'},
        ];
    }
}